import * as React from "react"
import {AutocompleteAjaxSeeker} from "@ui-seeker/core"

import { WEBBACK_V2_API } from "@constants"
import { country, keyword, retailer } from "@signals";

export default function DIPKeyword({ options, ...props }) {

    return <AutocompleteAjaxSeeker
        urlAjax={`${WEBBACK_V2_API}/master-data/keyword/options`}
        label="Keyword"
		placeholder="All keywords..."
		multiple
        value={keyword.value}
        onChange={e => keyword.value = e.target.value}
        filters={{ country: country.value, retailer: retailer.value }}
        {...props}
    />
}